import * as React from 'react';

import {GraphQLSelectUsers} from '../../core/select/graphql-select-users';

import {ListActionsTable} from './list-actions-table';

import styles from './audit-log.module.css';

type Props = {
    onParamChange: (params: any) => void;
    filterByUserId: string | null | undefined;
};

export function ListActionsTab(props: Props) {
    // Purposely typed 'any' to appease Flow. Since we are using GraphQLSelectUsers
    // for a single value, not multi, we get a single ListOptionWithIcon in the onChange
    // and not an array, but typing this is proving difficult
    const onSelectUsers = (selection: any) => {
        props.onParamChange({userId: selection.value});
    };

    const onClearSelectedUsers = () => {
        props.onParamChange({userId: null});
    };

    return (
        <div>
            <div className={styles.filter}>
                <GraphQLSelectUsers
                    selectedId={props.filterByUserId}
                    onChange={onSelectUsers}
                    onClearValue={onClearSelectedUsers}
                    noResultsText='No users were found'
                    valueKey='value'
                    labelKey='label'
                    autoBlur={true}
                    isMulti={false}
                    autoFocus={false}
                    includeUnprovisioned={true}
                />
            </div>
            <ListActionsTable filterByUserId={props.filterByUserId} />
        </div>
    );
}
